import { ApplicationState } from ".";

export interface CommandResult {
    commandId: string,
    isSuccess: boolean,
    errorMessage: string
};

export async function query<T>(
    url: string,
    state: ApplicationState,
    data: any,
    requestCache: RequestCache
) : Promise<T> {
    var requestInit: RequestInit = {
        method: 'GET',
        headers: createHeaders(state, false),
        mode: 'cors',
        cache: requestCache
    };

    const urlConParametri = createRequestUrl(url, data);
    const response = await fetch(urlConParametri, requestInit);

    const responseJson = await response.json();
    
    if (!response.ok) {
        throw new Error(responseJson);
    }
    
    return responseJson;
}

export async function command(
    url: string,
    state: ApplicationState,
    data: string | FormData
): Promise<string> {
    var requestInit: RequestInit = {
        method: 'POST',
        headers: createHeaders(state, typeof data === 'string'),
        mode: 'cors',
        body: data,
    };

    const response = await fetch(url, requestInit);
    const responsejson = await response.json();

    if (!response.ok) {
        throw new Error(responsejson);
    }
    
    return responsejson;
}

function createHeaders(state: ApplicationState, addJson: boolean) : Headers {
    var headers = new Headers();
    if (addJson) {
        headers.append("Content-Type", "application/json");
    }

    if (state.core.auth.user !== undefined) {
        headers.append("Authorization", "Bearer " + state.core.auth.user.access_token);
    }
    if (state.core.anagrafiche.anagrafica !== undefined) {
        headers.append("NEiTAnagrafica", state.core.anagrafiche.anagrafica.idAnagrafica);
    }

    return headers;
}

function createRequestUrl(url: string, data: any): string {
    const keys = Object.keys(data);
    if (keys.length === 0) return url;

    var queryString = keys
        .filter((key: string): boolean => data[key] !== undefined)
        .map(key => key + '=' + data[key])
        .join('&');

    return url + "?" + queryString;
}